import type { FaireProductEntity } from "../../entity_types/product";

export const p_3cn72ysn2u: FaireProductEntity = {
  token: "p_3cn72ysn2u",
  type: "product",
  name: "Greetings From Case - 24 Cans",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/e033b0eb23b31d620a71904f7f4b13968eea3e93d3486b61c0fee4f2128b2835.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/834e7607f7daa12131b86ab8924ac5d51c0f4b551fb749a029e561d29e49032c.png",
    "https://cdn.faire.com/fastly/9d887b0c4fed70659ef64c4fe6b548cde01baa53545d0855cb1f748a4e2e946e.png",
    "https://cdn.faire.com/fastly/061bc80576aaee536ad8effbcbc9cd50d26c246345b620d272725e4f9528e6a2.png"
  ],
  priceDollars: 2.75,
  description: "This is our first Limited Edition coffee soda to become a mainstay, thanks to the love it consistently receives. Greetings From, our passion fruit coffee soda, highlights deep tropical flavors with a hint of sea salt. Whether you’re traveling abroad or on a joy ride at home, the final product will make you feel like you’re ocean-side no matter where you are.\n\nAt Comeback, we source high-quality natural ingredients to combine with our in-house roasted and flash-chilled coffee. Shaking up the typical flavors often combined with coffee, we rejoin coffee with its first home, fruit.\n",
  tags: [],
  msrpDollars: 5.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:32.981Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
